import React, { Component } from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import Helmet from 'react-helmet';
import CookieBanner from 'react-cookie-banner';
import 'what-input';
import axios from 'axios';
import logoImg from './logo.png';
import QuestionList from './components/QuestionList/QuestionList';
import ResultModal from './components/ResultModal/ResultModal';
import Footer from './components/Footer/Footer';
import './App.css';
import './modifiers.css';
import {parseQueryString} from './helpers';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      winner: null,
      recommendations: null,
      status: "READY",
      aggregatedQuestions: [
      ],
      basket: [],
      totalQuestions: null,
      currentQuestion: 0,
      popQuestion: null,
      popAnswer: null,
      activeResult: null,
      showBasket: false,
      showBanner: true,
      utm: {
        source: "direct",
        medium: "fragrance_profiler",
        campaign: "",
        term: "",
        content: "",
      },
    }
    this.pushAnswer = this.pushAnswer.bind(this);
    this.getWeighting = this.getWeighting.bind(this);
    this.addToBasket = this.addToBasket.bind(this);
    this.removeFromBasket = this.removeFromBasket.bind(this);
    this.setTotalQuestions = this.setTotalQuestions.bind(this);
    this.setCurrentQuestion = this.setCurrentQuestion.bind(this);
    this.setActiveResult = this.setActiveResult.bind(this);
    this.toggleBasketVisibility = this.toggleBasketVisibility.bind(this);
  }

  pushAnswer(answer, oldAnswer) {
    let {aggregatedQuestions} = this.state;
    if(oldAnswer.length) {
      oldAnswer.map( o => {
        return aggregatedQuestions = aggregatedQuestions.filter( a => a !== o.weightingName );
      })
    }
    aggregatedQuestions.push(answer);
    this.setState({ aggregatedQuestions: aggregatedQuestions });
  }

  addToBasket(item) {
    const {basket} = this.state;
    basket.push(item);
    this.setState({ basket: basket });
  }

  toggleBasketVisibility() {
    this.setState({ showBasket: !this.state.showBasket });
  }

  removeFromBasket(item) {
    const {basket} = this.state;
    let newBasket = basket.filter(b => b.fields.name !== item.fields.name);
    this.setState({ basket: newBasket });
  }

  getWeighting(answers) {
    this.setState({ status: "LOADING" });
    axios.get('https://us-central1-penfrag-ae15f.cloudfunctions.net/getProfilesWithColours')
      .then( res => {
        console.log(res);
        const fragranceList = res.data.filter(function(n){ return n != null });
        let winningWeight = 0;
        let winner = {};
        // Loop through the fragrance list and assign weightings
        fragranceList.map( (profile, index) => {
          console.log(profile);
          if(!profile && !profile.fields) {
            return null;
          }
          profile.weighting = 0;
          // Loop through all qualities and check if they exist in answers array
          Object.keys(profile.fields).map( (key) => {
            if(answers.includes(key)) {
              // add trhe weighting if they do
              profile.weighting += Number(profile.fields[key]);
            }
            return profile.weighting;
          });

          if(profile.weighting > winningWeight) {
            winningWeight = profile.weighting;
            winner = profile;
          }
          return winner;
        });
        fragranceList.sort( (a, b) => {
          return b.weighting - a.weighting;
        })
        if(!winner.fields) {
          winner = fragranceList[0];
          fragranceList.shift();
        }
        this.trackEvent('Fragrance_Experience', `Recommended: ${winner.fields.name}`, 'Recommended', { "product": winner.fields.name });
        return this.setState({ recommendations: fragranceList, winner: winner, status: "SUCCESS" });
      })
  }

  setTotalQuestions(amount) {
    this.setState({ totalQuestions: amount });
  }

  setCurrentQuestion(q) {
    this.setState({ currentQuestion: q, popQuestion: null, popAnswer: null });
  }

  setActiveResult(result) {
    this.setState({ activeResult: result });
  }

  componentDidMount() {
    const query = window.location.search.substring(1);
    const params = parseQueryString(query);
    if(params.utm_source || params.utm_campaign || params.utm_medium || params.utm_term || params.utm_content) {
      const utm = {
        source: params.utm_source ? params.utm_source : "",
        campaign: params.utm_campaign ? params.utm_campaign : "",
        medium: params.utm_medium ? params.utm_medium : "",
        term: params.utm_term ? params.utm_term : "",
        content: params.utm_content ? params.utm_content : "",
      }
      this.setState({ utm });
    }
    ReactGA.initialize('UA-3013057-17', {
      debug: true,
      titleCase: false,
      gaOptions: {
        userId: 123
      }
    });
    const tagManagerArgs = {
      gtmId: 'DC-8515401'
    }
    TagManager.initialize(tagManagerArgs);
    window.onpopstate = (event) => {
      this.setState({ status: "READY" });
      this.setState({
        popQuestion: event.state.q,
        popAnswer: event.state.a,
      });
    }
  }

  trackEvent(category, action, mixPanelAction, mixPanelMeta) {
    if(!mixPanelAction) {
      mixPanelAction = action;
    }
    window.mixpanel.track(mixPanelAction, mixPanelMeta);
    ReactGA.event({
      category: category,
      action: action
    });
  }

  trackPage(page) {
    ReactGA.pageview(page);
  }

  render() {
    const {
      winner,
      recommendations,
      status,
      aggregatedQuestions,
      basket,
      popQuestion,
      popAnswer,
      activeResult,
      showBanner
    } = this.state;
    return (
      <div className="App">
        <Helmet>
          { activeResult && winner ?
            <body className="noScroll resultsPage" />
          : null }
        </Helmet>
        <header className="App-header">
          <nav>
            <a href="https://penhaligons.com">
              <img src={logoImg} className="logo" alt="Penhaligon's Logo" />
            </a>
          </nav>
        </header>
        { showBanner ?
          <div className="wrapper cookieWrapper">
            <CookieBanner>
              {(onAccept) => (
                <div className="cookieBanner">
                  <div className="cookieContent">
                    <p>We rely on cookies to remember your preferences and analyse our websites. <a href="https://www.penhaligons.com/cookie-policy/" target="_blank" rel="noopener noreferrer">View our cookie policy</a>.</p>
                  </div>
                  <div className="cookieButtons">
                    <button onClick={onAccept} className="button serif">Accept</button>
                  </div>
                </div>
              )}
            </CookieBanner>
          </div>
        : null }
        <main className="App-content">
          <QuestionList
            pushAnswer={this.pushAnswer}
            status={status}
            results={recommendations}
            winner={winner}
            getWeighting={this.getWeighting}
            aggregatedQuestions={aggregatedQuestions}
            addToBasket={this.addToBasket}
            removeFromBasket={this.removeFromBasket}
            basket={basket}
            setTotalQuestions={this.setTotalQuestions}
            setCurrentQuestion={this.setCurrentQuestion}
            popQuestion={popQuestion}
            popAnswer={popAnswer}
            setActiveResult={this.setActiveResult}
            trackPage={this.trackPage}
            trackEvent={this.trackEvent}
          />
        </main>
        <footer className="App-footer">
          <Footer
            basket={basket}
            removeFromBasket={this.removeFromBasket}
            showSteps={!this.winner ? true : false}
            currentQuestion={this.state.currentQuestion + 1}
            totalQuestions={this.state.totalQuestions}
            showBasket={this.state.showBasket}
            toggleBasketVisibility={this.toggleBasketVisibility}
            stepClick={ (step) => this.setState({ popQuestion: step }) }
            trackPage={this.trackPage}
            trackEvent={this.trackEvent}
            utm={this.state.utm}
          />
        </footer>
        { activeResult ?
          <ResultModal
            {...activeResult}
            basket={basket}
            removeFromBasket={this.removeFromBasket}
            addToBasket={this.addToBasket}
            setActiveResult={this.setActiveResult}
            winner={winner}
            results={recommendations}
          />
        : null }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js